<template>
  <div class="BaseInput" :class="{ 'no-valid': !isValid }">
    <label v-if="label">{{ label }}</label>
    <input :value="modelValue" :type="type" :placeholder="placeholder || label" @input="handleInput" />
  </div>
</template>

<script setup lang="ts">
  interface Props {
    modelValue: any;
    type: 'text' | 'tel' | 'number' | 'password';
    isValid?: boolean;
    label?: string;
    placeholder?: string;
  }

  const emits = defineEmits(['update:modelValue']);
  withDefaults(defineProps<Props>(), {
    isValid: true,
    label: '',
    placeholder: '',
  });

  const handleInput = (event: Event) => {
    const value = (event.target as HTMLInputElement).value.trim();
    emits('update:modelValue', value);
  };
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .BaseInput {
    display: flex;
    flex-direction: column;
    label {
      margin-bottom: 0.3731vw;
      font-size: 2.0896vw;
      line-height: 100%;
      @media (max-width: vars.$md) {
        font-size: 14px;
      }
    }

    input {
      width: 100%;
      height: 4.4776vw;
      border: 1px solid #dededf;
      border-radius: 4px;
      padding-left: 0.7463vw;
      font-size: 2.0896vw;
      @media (max-width: vars.$md) {
        height: 30px;
        font-size: 14px;
      }
      &::placeholder {
        padding-left: 0.7463vw;
        color: #dcdcdc;
      }
    }

    &.no-valid input {
      border: 1px solid red;
    }
  }
</style>
